import { Box, Typography } from "@mui/material";

export const MonthHeader = ({ monthLabel }: { monthLabel: string }) => (
	<Box
		sx={{
			py: 0.5,
			px: 2,
			backgroundColor: "#faf2e9ff",
			borderBottom: "1px solid",
			borderBottomColor: "divider",
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
		}}
	>
		<Typography variant="caption" fontWeight={900} sx={{ color: "#A18160" }}>
			{monthLabel}
		</Typography>
	</Box>
);
